import React, {Component} from 'react'
import styles from './SchedulerHour.css'
import PropTypes from 'prop-types'
import {LAYOUT_TYPE_HORIZONTAL, LAYOUT_TYPE_VERTICAL} from './Scheduler'
import SchedulerContext from './SchedulerContext'

const WIDTH_HOUR = 59
const HEIGHT_HOUR = 29.5

export class SchedulerHour extends Component {
  _context = {}
  _element = React.createRef()

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return (
      nextProps.selected !== this.props.selected ||
      nextProps.conflict !== this.props.conflict ||
      nextProps.date !== this.props.date
    )
  }

  componentDidUpdate() {
    if (this.props.conflict) {
      this._context.saveConflictPos({
        day: this.props.day,
        x: this._element.current.offsetLeft,
        y: this._element.current.offsetTop,
        width: this._element.current.offsetWidth,
        height: this._element.current.offsetHeight
      })
    }
  }

  _renderContent = options => {
    this._context = options
    const className =
      this._getBaseClassName() + ' ' + this._getFunctionalClassName()

    return (
      <div
        ref={this._element}
        className={className}
        style={{minWidth: this._getWidth(), minHeight: this._getHeight()}}
        onMouseDown={this.onSelectStart}
        onMouseUp={this.onSelectEnd}
        onTouchStart={this.onSelectStart}
        onTouchEnd={this.onSelectEnd}
      />
    )
  }

  _getBaseClassName = () => {
    const {layout} = this._context
    return layout === LAYOUT_TYPE_HORIZONTAL
      ? styles.bodyHorizontalCell
      : styles.bodyVerticalCell
  }

  _getFunctionalClassName = () => {
    const {busy, selected, conflict} = this.props

    if (conflict) return styles['conflictCell']
    if (busy) return styles['busyCell']
    if (selected) return styles['selectCell']

    return ''
  }

  _getWidth = () => {
    if (this._context.layout === LAYOUT_TYPE_VERTICAL) {
      return '100%'
    }
    const {blocks, time} = this.props
    if (time === 0 || blocks === 1) return undefined

    return WIDTH_HOUR * blocks + (blocks - 1)
  }

  _getHeight = () => {
    if (this._context.layout === LAYOUT_TYPE_HORIZONTAL) {
      return undefined
    }
    const {blocks, time} = this.props
    if (time === 0 || blocks === 1) return undefined

    return HEIGHT_HOUR * blocks + (blocks - 1)
  }

  onSelectStart = dom => {
    const {day, time, busy} = this.props
    if (busy) return

    this._context.onSelectStart(time, day, dom)
  }

  onSelectEnd = () => {
    if (this.props.busy) return

    this._context.onSelectEnd()
  }

  render() {
    return (
      <div>
        <SchedulerContext.Consumer>
          {values => this._renderContent(values)}
        </SchedulerContext.Consumer>
      </div>
    )
  }
}

SchedulerHour.defaultProps = {
  time: -1,
  day: new Date(),

  busy: false,
  selected: false,
  conflict: false,

  blocks: 1
}
SchedulerHour.propTypes = {
  time: PropTypes.number.isRequired
}
